module.exports = __webpack_public_path__ + "static/media/tr-TR.6f1dd341.md";